import { useEffect } from "react";
import { StandardProps } from "../componentMap";

export const Debugger = ({ flags }: Pick<StandardProps, "flags">) => {
  useEffect(() => {
    window.pdpScaffold ??= {};
    window.pdpScaffold.listFlags = () => {
      // eslint-disable-next-line no-console
      console.table(flags);
    };
  });

  return null;
};
